import { render, staticRenderFns } from "./event_organizer.vue?vue&type=template&id=9f2babc2"
import script from "./event_organizer.vue?vue&type=script&lang=js"
export * from "./event_organizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports